import React from 'react';
import { view } from '@yola/ws-sdk';

const prepareElementSettings = (elements, elementSettings) =>
  elements.reduce((settingsMap, element) => {
    const matchedSettings = elementSettings.filter((setting) => {
      const isSettingAlreadyPrepared = settingsMap.some(({ id }) => id === setting.id);
      const isSettingMatches = setting.matches(element, setting.settings);

      return isSettingMatches && !isSettingAlreadyPrepared;
    });

    if (!matchedSettings) return settingsMap;

    matchedSettings
      .sort((a, b) => b.priority - a.priority)
      .forEach((setting) => {
        const { settings } = setting;
        let targetElement = element;

        if (setting.getTargetElement) {
          targetElement = setting.getTargetElement(targetElement, settings);
        }

        const elementId = view.accessors.getLiveElementId(targetElement);

        if (!elementId) return;

        const preparedTabs = setting.tabs.map((tab) => {
          const tabId = `${setting.id}-${tab.id}`;

          return {
            ...tab,
            id: tabId,
            component: React.createElement(tab.component, {
              tabId,
              elementId,
              settingId: setting.id,
            }),
          };
        });

        const preparedSettings = {
          priority: 0,
          ...setting,
          tabs: preparedTabs,
          elementId,
        };

        settingsMap.push(preparedSettings);
      });

    return settingsMap;
  }, []);

export default prepareElementSettings;
